const Legal = () => {
  return (
    <div className="container mt-20 md:mb-10">
      <h1 className="text-2xl font-bold text-center text-black">
        Mentions légales
      </h1>

      <div className="mt-20 text-black mb-96">
        <p>
          En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la
          confiance dans l’économie numérique, il est précisé aux utilisateurs
          du site www.hydreaulys.fr l’identité des différents intervenants dans
          le cadre de sa réalisation et de son suivi :
        </p>

        <p>
          <ul className="ml-5 list-disc">
            <li>
              Propriétaire : AQUAVESC – SIRET : 25780022700031 – 12 rue Mansart,
              78000 VERSAILLES
            </li>{" "}
            <li>
              Responsable publication : Marc Tourelle –{" "}
              <a href="mailto:contact@etaso.fr" className="text-primary">
                E-mail
              </a>
            </li>{" "}
            <li>
              Webmaster : Philippe Leroy –{" "}
              <a href="mailto:contact@etaso.fr" className="text-primary">
                E-mail
              </a>
            </li>
            <li>Création et Hébergement : BIGUP CONSEILS et IONOS</li>
          </ul>
        </p>
      </div>
    </div>
  );
};

export default Legal;
